/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export const pageNotFound = {

    button: {
        back: `Atpakaļ`,
    },
    text: {
        caption1: `Lapa, kuru vēlies atvērt, neeksistē.`,
        caption2: `Ja Jums liekas, ka šādai lapai vajadzētu eksistēt, ziņojiet par to KLASIS administratoram.`,
        heading: `Lapa neeksistē`,
    },
}
